<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive && isRouterAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function() {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>

<style>
*{
  font-family: PingFang SC;
}
input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{
  -webkit-appearance: none !important; 
}
input[type="number"]{
  -moz-appearance:textfield;/* firefox */
}
#app {
  margin: 0;
  padding: 0;
  height: 100%;
}
ul,
li {
  list-style: none;
}
* {
  margin: 0;
  padding: 0;
}
.nextPage {
  bottom: 5.5%;
  background-size: 100%;
  animation: toggleMove 0.8s infinite;
  -moz-animation: toggleMove 10.8s infinite;
  -webkit-animation: toggleMove 0.8s infinite;
  -o-animation: toggleMove 0.8s infinite;
}
@keyframes toggleMove {
  from {
    bottom: 20px;
  }
  to {
    bottom: 40px;
  }
}
.btn-toggle {
  position: absolute;
  width: 26px;
  height: 20px;
  background-size: cover;
  z-index: 1200;
  left: 50%;
  margin-left: -13px;
}
</style>
<style lang="less">
.twoBannerHome{
  width: 100%;
  min-width: 1280px;
  overflow-x: scroll;
}
.title {
  width: 1200px;
  height: 80px;
  position: relative;
  z-index: 333;
  margin: 0 auto;
  top: 0;
  left: 0;
  img {
    width: 120px;
    height: 41px;
    margin-top: 20px;
  }
  .tabItem {
    width: auto;
    height: 80px;
    line-height: 80px;
    float: right;
    li {
      float: left;
      font-size: 20px;
      color:#333333;
      padding: 0 15px;
      box-sizing: border-box;
      cursor: pointer;
      margin: 0 10px;
    }
    .active {
      color: #1D5EEA;
      font-size: 24px;
      opacity: 1;
      font-weight: bold;
    }
    li:last-child {
      margin-right: 0;
      padding-right: 0;
    }
  }
}
</style>
